
import Bugsnag from '@bugsnag/js';
import GwRadio from '~/patterns/atoms/radio/radio.vue';

export default {
    components: {
        GwRadio
    },
    props: {
        customerCountry: {
            type: String,
            default: null
        },
        administration: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            paymentMethods: [],
            chosenMethod: null
        };
    },
    watch: {
        customerCountry() {
            this.getPaymentMethods();
        },
        administration() {
            this.getPaymentMethods();
        },
        chosenMethod() {
            this.$emit('methodChosen', this.chosenMethod);
        }
    },
    mounted() {
        this.getPaymentMethods();
    },
    methods: {
        async getPaymentMethods() {
            try {
                await this.$axios.post(this.$config.apiUrl + '/api/orders/payments', { countryCode: this.customerCountry, administration: this.administration })
                    .then(({ data }) => {
                        this.paymentMethods = data;
                    });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);

                Bugsnag.notify(error, (event) => {
                    event.addMetadata('payment-method', {
                        countryCode: this.customerCountry
                    });
                });
            }
        }
    },
};
